<template>
    <div>
      <TitleBar>
        <template v-slot:title>
          <translate>Intracommunautaire Prestaties</translate>
        </template>
        <template v-slot:buttons>
            <GekkoButton :text="$gettext('New Report')" type="button" v-if="isAccountantUser"  class="mr-2"
                        @click="year = null; quarter = null; showNewReportModal = true" />
            <GekkoButton v-if="!$route.path.includes('control-panel')"
                        :text="$gettext('All Reports')" icon="fa-solid fa-chart-column" type="button"
                        variant="outline-primary" :to="{ name: 'Reports' }" />
        </template>
      </TitleBar>

      <ReportsVATNewModal
          v-if="showNewReportModal"
          @close="onNewReportClose"
          @submit="onNewReportSubmit"
          :financialYears="financialYears"
          :year="year"
          :quarter="quarter"
          :month="null"
          :consolidated="false"
          :onlyQuarter="false"
          :overrideMessage="true"
      />

      <div class="content">
        <div class="row">
          <div class="col-lg-11 col-md-11 col-xs-11">
            <ul class="list-unstyled reports-list" v-for="aYearOfReports in reportsByYear" :key="aYearOfReports.id">
              <template>
                <h2>{{ aYearOfReports.year }}</h2>
                <li v-for="report in _orderedReports(aYearOfReports.reports)" :key="report.id">
                  <div v-if="!report.month">
                    <div v-if="!report.blank">
                      <GekkoButton class="primary" icon="fa fa-eye"
                                  v-bind:text="$gettext('report for ') + report.quarter + ' ' + aYearOfReports.year + ' (' + $gettext('Calculated on: ') + $options.filters.formatDate(report.modified) + ')'"
                                  variant="link"
                                  :to="{ name: 'EUServicesReport', params: { id: report.id }}" />
                    </div>
                    <div v-if="report.blank">
                      <GekkoButton class="text-blue" icon="fa fa-plus-circle"
                                  :text="$gettext('new report for ') + report.quarter + ' ' + aYearOfReports.year"
                                  variant="link"
                                  @click="preselectedGenerateReportModal(report.year, report.quarter)"
                      />
                    </div>
                  </div>
                  <div v-if="report.month">
                    <div v-if="!report.blank">
                        <ul class="monthly-list">
                            <li>
                                <GekkoButton icon="fa fa-eye"
                                    v-bind:text="$gettext('report for ') +
                                    $options.filters.getMonth(report.month, MONTHS) + aYearOfReports.year" variant="link"
                                    :to="{ name: 'EUServicesReport', params: { id: report.id }}" />
                            </li>
                        </ul>
                    </div>
                    <div v-if="report.blank">
                        <ul class="monthly-list">
                            <li>
                                <GekkoButton class="text-blue" icon="fa fa-plus-circle"
                                    v-bind:text="$gettext('new report for ') +
                                        $options.filters.getMonth(report.month, MONTHS) + aYearOfReports.year" variant="link"
                                    @click="preselectedGenerateReportModal(report.year, report.quarter, report.month)"
                                />
                            </li>
                        </ul>
                    </div>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import ReportsVATNewModal from "@/components/ReportsVATNewModal";
  import settingsPageSetup from "@/mixins/settingsPageSetup";
  import EUServicesReportService from "@/store/services/euservicesreport.service";
  import CompanyService from "@/store/services/company.service";
  import GekkoButton from "@/components/GekkoButton";
  import TitleBar from "@/components/TitleBar";
  import { mapGetters } from "vuex";
  
  export default {
    name: "EUServicesList",
    components: { TitleBar, ReportsVATNewModal, GekkoButton },
    mixins: [settingsPageSetup],
    computed: {
      ...mapGetters ({
        visitingCompanyId: 'main/getVisitingCompanyId'
      })
    },
    data() {
      return {
            pageSettings: {
                title: this.$gettext("Reports"),
                showCompanyPicker: true
            },
            isAccountantUser: true,
            reportsByYear: [],
            reports: [],
            financialYears: [],
            showNewReportModal: false,
            year: null,
            quarter: null,
            MONTHS: [
                { text: this.$gettext('Jan'), value: { month: 1, quarter: 'Q1' } },
                { text: this.$gettext('Feb'), value: { month: 2, quarter: 'Q1' } },
                { text: this.$gettext('Mar'), value: { month: 3, quarter: 'Q1' } },
                { text: this.$gettext('Apr'), value: { month: 4, quarter: 'Q2' } },
                { text: this.$gettext('May'), value: { month: 5, quarter: 'Q2' } },
                { text: this.$gettext('Jun'), value: { month: 6, quarter: 'Q2' } },
                { text: this.$gettext('Jul'), value: { month: 7, quarter: 'Q3' } },
                { text: this.$gettext('Aug'), value: { month: 8, quarter: 'Q3' } },
                { text: this.$gettext('Sep'), value: { month: 9, quarter: 'Q3' } },
                { text: this.$gettext('Oct'), value: { month: 10, quarter: 'Q4' } },
                { text: this.$gettext('Nov'), value: { month: 11, quarter: 'Q4' } },
                { text: this.$gettext('Dec'), value: { month: 12, quarter: 'Q4' } }
            ]
        }
    },
    filters: {
      formatDate: function (value) {
        var options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(value).toLocaleDateString("en-US", options);
      },
      getMonth: function (value, months) {
          if (!months) return
          const result = months.filter(month => month.value.month == value);
          return result[0].text;
      }
    },
    created() {
      Promise.all([
        EUServicesReportService.list({'company_profile': this.visitingCompanyId}),
        CompanyService.financiallyActiveYears(this.visitingCompanyId)
      ]).then((responses) => {
        this.reports = responses[0].data;
        this.financialYears = responses[1].data;
        this.reportsByYear = this._reorganizeReports(this.financialYears, this.reports);
      })
    },
    methods: {
      preselectedGenerateReportModal(year, quarter, month) {
        this.year = year
        this.quarter = quarter
        this.month = month
        this.showNewReportModal = true
      },
      _reorganizeReports(years, reports) {
          var outputReports = [];
          for (var i = 0; i < years.length; i++) {
              var thisYear = years[i];
              var thisYearReports = {
                  year: parseInt(thisYear),
                  reports: {
                      Q1: { quarter: 'Q1', month: null, year: thisYear, blank: true },
                      Q2: { quarter: 'Q2', month: null, year: thisYear, blank: true },
                      Q3: { quarter: 'Q3', month: null, year: thisYear, blank: true },
                      Q4: { quarter: 'Q4', month: null, year: thisYear, blank: true }
                  }
              };
              for (var j = reports.length-1; j>-1; j--) {
                  if (reports[j].year === parseInt(thisYear)) {
                      if (reports[j].month) {
                          if (thisYearReports.reports[reports[j].quarter]) {
                              delete thisYearReports.reports[reports[j].quarter];
                              var base = 3 * (reports[j].quarter[1] - 1);
                              thisYearReports.reports[base + 1] = { quarter: reports[j].quarter, month: base + 1, year: thisYear, blank: true };
                              thisYearReports.reports[base + 2] = { quarter: reports[j].quarter, month: base + 2, year: thisYear, blank: true };
                              thisYearReports.reports[base + 3] = { quarter: reports[j].quarter, month: base + 3, year: thisYear, blank: true };
                          }
                          thisYearReports.reports[reports[j].month] = reports[j];
                      } else {
                          reports[j].month = null;
                          thisYearReports.reports[reports[j].quarter] = reports[j];
                      }
                  }
              }
              outputReports.push(thisYearReports);
          }
          return outputReports;
      },
      _orderedReports(reports) {
          //Ordered by month and quarter, in descending order
          var reportsArray = Object.entries(reports);
          reportsArray.sort(([, a], [, b]) => b.month - a.month);
          reportsArray.sort(function compareQuarters([, a], [, b]) {
              if (a.quarter > b.quarter) {
                  return -1;
              }
              if (a.quarter < b.quarter) {
                  return 1;
              }
              return 0;
          });
          var reportsArrayResult = [];
          reportsArray.forEach(element => {
              reportsArrayResult.push(element[1]);
          });
          return reportsArrayResult;
      },
      onNewReportSubmit(report_initial_values){
        this.showNewReportModal = false
        this.$store.commit('taxreports/setEUServicesReportInitialValues', report_initial_values)
        this.$router.push({ name: 'EUServicesReportCreate' })
      },
      onNewReportClose() {
        this.showNewReportModal = false
      }
    }
  }
  </script>
  <style scoped>
  ul {
    list-style-type: none;
  }
  </style>